import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      actions: false,
      comments: [],
      isLoading: true,
      onCancel: false,
      fullPage: true,
      loading: false,
      comment: {
        content: null
      },
      max: 500
    }
  },
  props: {
    meeting: {
      type: Object,
      require: true
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    formatDate (dt) {
      return moment(dt, 'YYYYMMDD HH:mm').format('DD/MM/YYYY HH:mm')
    },
    doSave () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }

      const params = {
        content: this.comment.content,
        meeting_id: this.meeting.id
      }
      this.loading = true
      this.$http.post('/v1/dweller/meetings/comment', params)
        .then((data) => {
          if (data.id) {
            this.comment.content = null
            this.getMeetingComments()
            this.$v.reset()
          }
        })
        .catch((er) => {
          this.errors = er.data
          this.afterFailure(er)
        })
    },
    doClear () {
      this.comment.content = null
    },
    getMeetingComments () {
      this.$http.get('/v1/dweller/meetings/comment/' + this.meeting.id)
        .then((data) => {
          this.comments = data
          this.loading = false
        })
    },
    doDelete (comment) {
      this.loading = true
      this.$http.delete('/v1/dweller/meetings/comment/' + comment.id)
        .then((data) => {
          this.getMeetingComments()
          this.$v.reset()
        })
    },
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    }
  },
  mounted () {
    this.getMeetingComments()
  },
  validations: {
    comment: {
      content: {
        required
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/details/components/resources/index.js